import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import SecurityModal from '../setup/SecurityModal';
import ForgotPasswordModal from '../setup/ForgotPasswordModal';
import BrowsingModal from '../setup/BrowsingModal';
import { getLogInUrl } from '../constants';
import { AuthContext } from '../context/AuthContext';
import { showValidationAlert,showErrorAlert } from '../CustomBannerAlert';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash, FaInfoCircle } from "react-icons/fa";
import { Box, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import Logo from '../menubar/Logo';
import axios from 'axios';
import useMediaQuery from "@mui/material/useMediaQuery";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "none",
}));

function Login() {
  const navigate = useNavigate();
  const { setToken, setUserId, setUserNameData, setModuleAccess } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSecurityModalOpen, setIsSecurityModalOpen] = useState(false);
  const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
  const [isBrowsingModalOpen, setIsBrowsingModalOpen] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState(0);
  const isMobile = useMediaQuery("(max-width:768px)");

  useEffect(() => {
    setUsername('');
    setPassword('');
    setKey(prevKey => prevKey + 1);
    setIsBrowsingModalOpen(true);
  }, []);

  
const handleSignIn = async () => {
  if (!username.trim() || !password.trim()) {
      showErrorAlert("Employee ID and Password cannot be empty.");
      return;
  }

  try {
      setLoading(true);

      // ✅ Send login request using Axios
      const response = await axios.post(getLogInUrl(), {
          username,
          password
      }, {
          headers: { 'Content-Type': 'application/json' }
      });

      // ✅ If login is successful
      if (response.status === 200) {
          const data = response.data;

          setToken(data.token);
          setUserNameData(data.employeeName);
          setModuleAccess(data.moduleAccess);
          setUserId(username);

          if (data.isFirstTime) {
              setIsSecurityModalOpen(true);
          } else {
              navigate('/home');
          }
      }
  } catch (error) {
      // ✅ Handle server errors or network issues
      if (error.response) {
          // Server responded with a status outside of 2xx
          showErrorAlert(error.response.data.message || "Login failed.");
      } else if (error.request) {
          // No response received (network error)
          showErrorAlert("No response from server. Please try again.");
      } else {
          // Other unexpected errors
          showErrorAlert(error.message);
      }
  } finally {
      setLoading(false);
  }
};



  const handleOnSuccess = (data) => {
    setErrorMessage('');
    setIsSecurityModalOpen(false);
    setIsForgotPasswordModalOpen(false);
    setPassword('');
    showValidationAlert(data, "success");
  };

  return (
    <Box
      className="login-container"
      style={{
        backgroundImage: `url('/choppies/assets/${isMobile ? "homepagemobile.png" : "homepage.png"}')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center top",
        backgroundSize: "cover",
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {loading && <div className="loading-overlay"><span className="spinner"></span></div>}

      <Grid container spacing={0} className="login-bg" sx={{ flexGrow: 1 }}>
        <Grid item xs={12} className="login-content" sx={{ flexGrow: 1 }}>
          <Logo />
          <Item className="main-section" sx={{ height: "80%", textAlign: "right", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", paddingRight: "20px" }}>
            <div className="login-box" key={key}>
              <h2>Sign In<span className="red-dot">●</span></h2>
              <input type="text" placeholder="Employee Id" className="login-input" value={username} onChange={(e) => setUsername(e.target.value)} />
              <div className="password-container">
                <input type={showPassword ? "text" : "password"} placeholder="Password" className="login-input" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <button className="login-button" onClick={handleSignIn}>Sign In</button>
              {errorMessage && <p className="error-message">{errorMessage}</p>}
            

            <div className="login-footer">
              <br />
              <button className="forgotpwd-link" onClick={() => setIsForgotPasswordModalOpen(true)}>
                Forgot Password?
              </button>
              <FaInfoCircle
                className="info-icon"
                title="Need help? Please contact the admin."
                style={{ marginLeft: "8px", backgroundColor: "#555", borderRadius: "50%", padding: "2px" }}
              />
            </div>

            </div>
          </Item>
        </Grid>
      </Grid>

      <div className="bottom-text">
        <p>DIGITAL</p>
        <p>KNOWLEDGE</p>
        <p>PLATFORM</p>
      </div>

      {isBrowsingModalOpen && <BrowsingModal isOpen={isBrowsingModalOpen} onClose={() => setIsBrowsingModalOpen(false)} />}
      {isSecurityModalOpen && <SecurityModal isOpen={isSecurityModalOpen} onClose={() => setIsSecurityModalOpen(false)} onSuccess={handleOnSuccess} />}
      {isForgotPasswordModalOpen && <ForgotPasswordModal isOpen={isForgotPasswordModalOpen} onClose={() => setIsForgotPasswordModalOpen(false)} onSuccess={handleOnSuccess} />}
      <ToastContainer />
    </Box>
  );
}

export default Login;
